import ScheduleIllustration from '@gitlab/svgs/dist/illustrations/schedule-md.svg';
import { translate } from '../../../../utils/i18n';
import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.js';

const i18n = {
  EMPTY_HISTORY_TITLE: translate('DuoChat.emptyHistoryTitle', 'See your chat history'),
  EMPTY_HISTORY_COPY: translate('DuoChat.emptyHistoryCopy', 'Your previous chats will appear here.'),
  EMPTY_HISTORY_ALT: translate('DuoChat.emptyHistoryAlt', 'Clock icon with circular arrow, indicating chat history or time-based functionality')
};
var script = {
  name: 'DuoChatHistoryEmpty',
  i18n,
  ScheduleIllustration
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gl-align-center gl-flex gl-h-full gl-flex-col gl-items-center gl-justify-center gl-px-4 gl-py-6"},[_c('img',{staticClass:"gl-mb-5",attrs:{"src":_vm.$options.ScheduleIllustration,"alt":_vm.$options.i18n.EMPTY_HISTORY_ALT,"data-testid":"empty-state-illustration"}}),_vm._v(" "),_c('h3',{staticClass:"gl-neutral-900 gl-mb-4 gl-font-bold",attrs:{"data-testid":"empty-state-title"}},[_vm._v("\n    "+_vm._s(_vm.$options.i18n.EMPTY_HISTORY_TITLE)+"\n  ")]),_vm._v(" "),_c('p',{staticClass:"gl-align-center",attrs:{"data-testid":"empty-state-description"}},[_vm._v("\n    "+_vm._s(_vm.$options.i18n.EMPTY_HISTORY_COPY)+"\n  ")])])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
